module.exports = __webpack_public_path__ + "img/side-weixin.1b9b7434.png";